module.exports = __webpack_public_path__ + "media/packs/images/three-dots-4e21d0595467e4cd29d85230b62ce7f2.svg";